import { render, staticRenderFns } from "./Preisbewertung.vue?vue&type=template&id=ca6353e8&scoped=true&"
import script from "./Preisbewertung.vue?vue&type=script&lang=js&"
export * from "./Preisbewertung.vue?vue&type=script&lang=js&"
import style0 from "./Preisbewertung.vue?vue&type=style&index=0&id=ca6353e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6353e8",
  null
  
)

export default component.exports